// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        clear: both;
        margin-top: 6px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-flow: column;
                `,
                css`
                    flex-flow: column;
                `,
                null,
                null,
                null,
            ])};
    `,
};

actionsStyles.addToListButton = {
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
            ])}
    `,
};
actionsStyles.buttonsHidden = {
    css: css`
        display: flex;
    `,
};
